import { Component, OnInit, ViewChild, ComponentFactoryResolver, Input } from '@angular/core';
import {  CompoAfficheprimeDirective } from './affichePrimeDir.directive';
import { AutoResPrimeComponent } from './Automobile/autoresprime.component';
import { SanteResPrimeComponent } from './sante/santeresprime.component';
import { IndivResPrimeComponent } from './individuelleAccident/indivresprime.component';
import { VoyResPrimeComponent } from './voyage/voyresprime.component';
import { MrhResPrimeComponent } from './mrh/mrhresprime.component';


@Component({
  selector: 'app-afficheprimeCompo-Contenaire',
  template:`<ng-template [app-AffichePrimeDirective]="data"></ng-template>`
})
export class AffichePrimeContenaireComponent implements OnInit {
@Input('data') data:any
@ViewChild(CompoAfficheprimeDirective,{static:true}) adHost:CompoAfficheprimeDirective
 private componentRef:any
constructor( private componentFactoryResolver:ComponentFactoryResolver ) {

  }

 injectComponent(component){
  const componentFactory=this.componentFactoryResolver.resolveComponentFactory(component)
  const viewContainerRef=this.adHost.viewContainerRef
  
  viewContainerRef.clear()
  this.componentRef= viewContainerRef.createComponent(componentFactory) as any
 //ici je passe la donnée provenant de la directive
 this.componentRef.instance.data=this.data
 //componentRef.instance.presentPeriodecouvertureAuto()
}
  ngOnInit(): void {
   // throw new Error("Method not implemented.");
   //console.log(this.data);
   try {
    this.componentRef.destroy()
   } catch (error) {
     
   }
   //console.log(this.data);
   
   switch (this.data) {
    case "AUTOMOBILE":
      this.injectComponent(AutoResPrimeComponent);
      break;
   case "SANTE":
    this.injectComponent(SanteResPrimeComponent);
     break;
   case "INDIVIDUELLE":
    this.injectComponent(IndivResPrimeComponent);
   break;
   case "VOYAGE":
      this.injectComponent(VoyResPrimeComponent);
   break;
   case "MULTIRISQUE":
    this.injectComponent(MrhResPrimeComponent);
 break;
    default:
      break;
  }

  // 
  }

    
}
